/* eslint-disable */

/** Request to get the details of a specific incident */
export interface GetIncidentRequest {
  incident_id?: string;
}

/** Response for [GetIncidentRequest] */
export interface GetIncidentResponse {
  incident?: Incident;
}

/** Request to get a list of ongoing or recent incidents */
export interface GetIncidentsListRequest {
}

/** Response for [GetIncidentsListRequest] */
export interface GetIncidentsListResponse {
  incidents?: Incident[];
}

/** Subscribes the customer to receive status updates for a particular incident */
export interface SubscribeToIncidentRequest {
  /** The ID of the Incident to subscribe the customer to */
  incident_id?: string;
}

/** Response for [SubscribeToIncidentRequest] */
export interface SubscribeToIncidentResponse {
  success?: SubscribeToIncidentResponseSuccess | undefined;
  failure?: SubscribeToIncidentResponseFailure | undefined;
}

export interface SubscribeToIncidentResponseSuccess {
}

export interface SubscribeToIncidentResponseFailure {
  /** Reason for the action failing */
  reason?: string;
}

/** Unsubscribes the customer from receiving status updates for a particular incident */
export interface UnsubscribeFromIncidentRequest {
  /** The ID of the Incident to unsubscribe the customer from */
  incident_id?: string;
}

/** Response for [UnsubscribeFromIncidentRequest] */
export interface UnsubscribeFromIncidentResponse {
  success?: UnsubscribeFromIncidentResponseSuccess | undefined;
  failure?: UnsubscribeFromIncidentResponseFailure | undefined;
}

export interface UnsubscribeFromIncidentResponseSuccess {
}

export interface UnsubscribeFromIncidentResponseFailure {
  /** Reason for the action failing */
  reason?: string;
}

export interface Incident {
  /** ID of the Incident that can be used to subscribe to notifications */
  id?: string;
  /** Title of the Incident */
  title?: string;
  /** Further details of the Incident */
  details?: string;
  /** The UTC time, in millis since epoch for when the Incident was reported */
  reported_at?: number;
  /** Is the customer subscribed to the Incident */
  customer_subscribed?: boolean;
  /** Status of the incident */
  status?: IncidentStatus;
  /** The UTC time, in millis since epoch for when the Incident was marked as resolved */
  resolved_at?: number;
  /** Whether or not a customer can change their subscription status */
  customer_can_change_subscription?: boolean;
  /** The notification workflow used for the incident */
  workflow?: IncidentWorkflow;
}

/** buf:lint:ignore ENUM_VALUE_PREFIX */
export enum IncidentStatus {
  INCIDENT_UNSPECIFIED = "INCIDENT_UNSPECIFIED",
  INVESTIGATING = "INVESTIGATING",
  IDENTIFIED = "IDENTIFIED",
  RESOLVED = "RESOLVED",
}

/** buf:lint:ignore ENUM_VALUE_PREFIX */
export enum IncidentWorkflow {
  WORKFLOW_UNSPECIFIED = "WORKFLOW_UNSPECIFIED",
  SEND_VIA_FLACK = "SEND_VIA_FLACK",
}

export interface IncidentAlertsService {
  /** Returns a list of ongoing or recent incidents. */
  GetIncidentsList(request: GetIncidentsListRequest): Promise<GetIncidentsListResponse>;
  /** Returns the details of a specific incident from [GetIncidentsList]. */
  GetIncident(request: GetIncidentRequest): Promise<GetIncidentResponse>;
  /** Informs the backend that a customer would like to receive status updates for a particular incident. */
  SubscribeToIncident(request: SubscribeToIncidentRequest): Promise<SubscribeToIncidentResponse>;
  /** Informs the backend that a customer would no longer like to receive status updates for a particular incident. */
  UnsubscribeFromIncident(request: UnsubscribeFromIncidentRequest): Promise<UnsubscribeFromIncidentResponse>;
}
